/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-12 12:20:04
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-09 17:39:30
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ModuleCart/index.tsx
 */
import React from 'react';

import { Icon } from '@/src/tools/icon';
import { EnumModuleType } from '@/src/types/common/module';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

import styles from './style.module.less';

const moduleTypeI18nMapping = {
  [EnumModuleType.Carousel]: 'general.carousel',
  [EnumModuleType.ProductCarousel]: 'general.productCarousel',
  [EnumModuleType.Poster]: 'general.poster',
  [EnumModuleType.LongCanvas]: 'general.longCanvas',
  [EnumModuleType.Text]: 'general.textEditor',
  [EnumModuleType.ProductGrid]: 'general.productGrid',
  [EnumModuleType.ProductList]: 'general.productList',
  [EnumModuleType.Edm]: 'general.edm',
  [EnumModuleType.ProductContentCarousel]: 'general.productContentCarousel',
  [EnumModuleType.Subscription]: 'general.subscription',
  [EnumModuleType.ArticleCarousel]: 'general.articleCarousel',
  [EnumModuleType.ArticleList]: 'general.articleList',
  [EnumModuleType.Video]: 'general.video',
  [EnumModuleType.ResponsiveProductCarousel]: 'general.responsiveCarousel',
  [EnumModuleType.ResponsiveImageCarousel]: 'general.responsiveCarousel',
  [EnumModuleType.ResponsiveContentCarousel]: 'general.responsiveCarousel',
  [EnumModuleType.ResponsiveSubscription]: 'general.responsiveSubscription',
  [EnumModuleType.ResponsiveText]: 'general.responsiveText',
  [EnumModuleType.ResponsivePoster]: 'general.responsivePoster',
  [EnumModuleType.ResponsiveProductGrid]: 'general.responsiveGrid',
  [EnumModuleType.ResponsiveContentGrid]: 'general.responsiveGrid',
  [EnumModuleType.ResponsiveProductTab]: 'general.responsiveTab',
  [EnumModuleType.ResponsiveContentTab]: 'general.responsiveTab',
  [EnumModuleType.ResponsivePosterTab]: 'general.responsiveTab',
};

function ModuleCart({ moduleList, disabled }) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.container}>
      <div className={styles.title}>{getI18n('general.modules')}</div>
      {moduleList.map((item) => {
        const { type, onClick } = item;
        const ui = MODULE_MAP[type] || {};

        return (
          <div
            key={`${ui.name}-${Math.random()}`}
            className={styles.image}
            onClick={!disabled && onClick.bind(this, item.name)}>
            <span className={styles.normal}>{ui.icon}</span>
            <span className={styles.hover}>{ui.hoverIcon}</span>
            <span className={styles.type}>
              {getI18n(moduleTypeI18nMapping[type])}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default ModuleCart;

export const MODULE_MAP = {
  [EnumModuleType.Carousel]: {
    name: EnumModuleType.Carousel,
    type: 'Carousel',
    i18nKey: 'general.carousel',
    icon: <Icon type='iconcarousel' className={styles.icon} />,
    hoverIcon: <Icon type='iconcarousel-hover1' className={styles.icon} />,
  },
  [EnumModuleType.ProductCarousel]: {
    name: EnumModuleType.ProductCarousel,
    type: 'Product Carousel',
    i18nKey: 'general.productCarousel',
    icon: <Icon type='iconproductcarousel' className={styles.icon} />,
    hoverIcon: (
      <Icon type='iconproductcarousel-hover1' className={styles.icon} />
    ),
  },
  [EnumModuleType.Poster]: {
    name: EnumModuleType.Poster,
    type: 'Poster',
    i18nKey: 'general.poster',
    icon: <Icon type='iconposters' className={styles.icon} />,
    hoverIcon: <Icon type='iconposters-hover' className={styles.icon} />,
  },
  [EnumModuleType.LongCanvas]: {
    name: EnumModuleType.LongCanvas,
    type: 'Long Canvas',
    i18nKey: 'general.longCanvas',
    icon: <Icon type='iconlongcanvas' className={styles.icon} />,
    hoverIcon: <Icon type='iconlongcanvas-hover' className={styles.icon} />,
  },
  [EnumModuleType.Text]: {
    name: EnumModuleType.Text,
    type: 'Text Editor',
    i18nKey: 'general.textEditor',
    icon: <Icon type='icontext1' className={styles.icon} />,
    hoverIcon: <Icon type='icontext-hover' className={styles.icon} />,
  },
  [EnumModuleType.ProductGrid]: {
    name: EnumModuleType.ProductGrid,
    type: 'Grid',
    i18nKey: 'general.productGrid',
    icon: <Icon type='icongrid1' className={styles.icon} />,
    hoverIcon: <Icon type='icongrid-hover1' className={styles.icon} />,
  },
  [EnumModuleType.ProductList]: {
    name: EnumModuleType.ProductList,
    type: 'List',
    i18nKey: 'general.productList',
    icon: <Icon type='iconlist1' className={styles.icon} />,
    hoverIcon: <Icon type='iconlist-hover1' className={styles.icon} />,
  },
  [EnumModuleType.Subscription]: {
    name: EnumModuleType.Subscription,
    type: 'Subscription',
    i18nKey: 'general.subscription',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.Video]: {
    name: EnumModuleType.Video,
    type: 'Video',
    i18nKey: 'general.video',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveImageCarousel]: {
    name: EnumModuleType.ResponsiveImageCarousel,
    type: 'Carousel',
    i18nKey: 'general.responsiveCarousel',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveSubscription]: {
    name: EnumModuleType.ResponsiveSubscription,
    type: 'Subscription',
    i18nKey: 'general.responsiveSubscription',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },

  [EnumModuleType.ResponsivePoster]: {
    name: EnumModuleType.ResponsivePoster,
    type: 'Poster',
    i18nKey: 'general.responsivePoster',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveProductGrid]: {
    name: EnumModuleType.ResponsivePoster,
    type: 'Grid',
    i18nKey: 'general.responsiveGrid',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveContentGrid]: {
    name: EnumModuleType.ResponsivePoster,
    type: 'Grid',
    i18nKey: 'general.responsiveGrid',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveText]: {
    name: EnumModuleType.ResponsiveText,
    type: 'Text',
    i18nKey: 'general.responsiveText',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsivePosterTab]: {
    name: EnumModuleType.ResponsivePosterTab,
    type: 'Tab',
    i18nKey: 'general.responsiveTab',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveProductTab]: {
    name: EnumModuleType.ResponsiveProductTab,
    type: 'Tab',
    i18nKey: 'general.responsiveTab',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  [EnumModuleType.ResponsiveIframe]: {
    name: EnumModuleType.ResponsiveIframe,
    type: 'Iframe',
    i18nKey: 'general.responsiveIframe',
    icon: <Icon type='iconsubscription' className={styles.icon} />,
    hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  },
  //ResponsiveProductTab
  // [EnumModuleType.ResponsiveContentCarousel]: {
  //   name: EnumModuleType.ResponsiveContentCarousel,
  //   type: 'ResponsiveContentCarousel',
  //   icon: <Icon type='iconsubscription' className={styles.icon} />,
  //   hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  // },
  // [EnumModuleType.ResponsiveProductCarousel]: {
  //   name: EnumModuleType.ResponsiveProductCarousel,
  //   type: 'ResponsiveProductCarousel',
  //   icon: <Icon type='iconsubscription' className={styles.icon} />,
  //   hoverIcon: <Icon type='iconsubscription-hover' className={styles.icon} />,
  // },
};
